// extracted by mini-css-extract-plugin
export default {"hide-scrollbar":"_classes_hide-scrollbar__u4j5C"};